import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyDdMLpAelSZNOE0iy_DfeZ3Adi98xFMDMk",
    authDomain: "linkxdxn.firebaseapp.com",
    projectId: "linkxdxn",
    storageBucket: "linkxdxn.appspot.com",
    messagingSenderId: "458194109460",
    appId: "1:458194109460:web:77ec5f8454819d2ca89301"
};

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage();

export { auth, provider, storage };
export default db;
